<template>
  <div class="personal-box">
    <div class="sign-out">
      <div class="sign-out-info-wrapper">
        <div class="sign-out-info">
          <div class="sign-out-img">
            <img
              src="@/assets/images/icon-person.svg"
              alt=""
            >
          </div>
          <div class="sign-out-main">
            <div class="sign-out-title">
              Welcome back,
            </div>
            <div class="sign-out-email">
              {{ maskedEmail }}
            </div>
          </div>
        </div>
      </div>
      <div class="person-menu">
        <div
          @click="handleMenuItemClick('cart')"
          class="person-menu-item"
        >
          <img
            v-if="cartStore.cartCount"
            class="item-icon"
            src="@/assets/H5/order/full-carts.svg"
            alt=""
          >
          <img
            v-else
            class="item-icon"
            src="@/assets/H5/order/carts.svg"
            alt=""
          >
          <div class="item-text">
            My Carts <span
              v-if="cartStore.cartCount"
              class="nums"
            >{{ cartStore.cartCount > 99 ? '99+' : cartStore.cartCount }}</span>
          </div>
        </div>
        <div
          @click="handleMenuItemClick('order')"
          class="person-menu-item"
        >
          <Icon
            class="item-icon"
            name="order-l"
            alt=""
          />
          <div class="item-text">
            Fulfillment Orders
          </div>
        </div>
        <div
          @click="handleMenuItemClick('address')"
          class="person-menu-item"
        >
          <img
            class="item-icon"
            src="@/assets/header/address.svg"
            alt=""
          >
          <div class="item-text">
            Shipping Address
          </div>
        </div>
        <div
          @click="handleMenuItemClick('dropshipping')"
          class="person-menu-item"
        >
          <img
            class="item-icon"
            src="@/assets/images/bound_store.svg"
            alt=""
          >
          <div class="item-text flex-center">
            {{ hasBoundStore ? 'Go Dropshipping' : 'Link Store' }}
            <span
              v-if="!hasBoundStore"
              class="suffix"
            >NEW</span>
          </div>
        </div>
      </div>
      <div class="split-line" />
      <div class="footer-menu">
        <div
          @click="handleMenuItemClick('help')"
          class="menu-item"
        >
          Help Center
        </div>
        <div
          @click="handleMenuItemClick('signOut')"
          class="menu-item"
        >
          Sign Out
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { buriedPointUtil } from '@/utils/utils'
import { useLogin } from '@/components/Login'
import { useUserStore } from '@/pinia/user'
import { useCartStore } from '@/pinia/cart'
import { useAddressStore } from '@/pinia/address'
import { useDropshipping } from '@/components/Dropshipping/useDropshipping'
import { Icon } from '@/components/Icon'

const { hasBoundStore, onDropshipping } = useDropshipping()

const router = useRouter()

const cartStore = useCartStore()

const addressStore = useAddressStore()

const { logout } = useLogin()

const user = useUserStore()

const userInfo = computed(() => user.userInfo || {})

const maskedEmail = computed(() => {
  if (!userInfo?.value?.email) {
    return ''
  }
  const [username, domain] = userInfo?.value?.email?.split('@')
  return username.slice(0, 3) + '***' + username.slice(-3) + '@' + domain
})

const handleMenuItemClick = (type) => {
  const popoverTrigger = document.querySelector('.search-person')
  if (popoverTrigger) {
    popoverTrigger.dispatchEvent(new Event('mouseleave', { bubbles: true }))
  }
  switch (type) {
    case 'cart':
      buriedPointUtil({ eventId: 'PPC201' })
      router.push('/carts')
      break
    case 'order':
      router.push('/orders')
      break
    case 'address':
      addressStore.show(3)
      break
    case 'help':
      router.push('/help')
      break
    case 'signOut':
      logout()
      break
    case 'dropshipping':
      onDropshipping()
      break
    default:
      break
  }
}
</script>

<style lang='less' scoped>
.personal-box {
  padding: 16px;
  width: 240px;
  .sign-out {
    .sign-out-info {
      display: flex;
      align-items: center;
      padding-bottom: 16px;
      border-bottom: 1px solid #EBF1F5;

      .sign-out-img {
        width: 36px;
        height: 36px;
      }

      .sign-out-main {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 8px;
        height: 30px;

        .sign-out-title {
          font-family: mon-500;
          color: #232323;
          font-size: 11px;
          line-height: 14px;
        }

        .sign-out-email {
          font-size: 11px;
          font-family: mon-600;
          line-height: 14px;
          color: #232323;
        }

        .sign-out-btn {
          margin-top: 8px;
          font-family: mon-500;
          font-size: 10px;
          line-height: 14px;
          color: #009de0;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .person-menu {
      margin-top: 8px;
      .person-menu-item {
        display: flex;
        align-items: center;
        gap: 8px;
        height: 40px;
        margin-bottom: 4px;
        &:hover {
          background-color: #f5f5f5;
          border-radius: 4px;
          cursor: pointer;
        }
        .item-icon {
          width: 16px;
          height: 16px;
          font-size: 16px;
          margin-left: 4px;
        }
        .item-text {
          color: #232323;
          font-size: 12px;
          font-family: mon-500;
          &.flex-center {
            display: flex;
            align-items: center;
          }
          .nums {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-left: 4px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #009de0;
            color: white;
            font-size: 10px;
            font-family: mon-600;
          }

          .suffix {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 4px;
            width: 30px;
            height: 16px;
            background-color: #1b3e9c;
            color: white;
            border-radius: 2px;
            font-size: 10px;
            font-family: mon-600;
          }
        }
      }
    }

    .split-line {
      width: 100%;
      height: 1px;
      background-color: #EBF1F5;
      margin: 8px auto;
    }

    .footer-menu {
      .menu-item {
        height: 32px;
        line-height: 32px;
        color: #5C5C5C;
        font-size: 12px;
        font-family: mon-500;
        &:hover {
          color: #004f9a;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
